module.exports = __webpack_public_path__ + "static/media/snjob-logo.41390986.png";